// extracted by mini-css-extract-plugin
var _1 = "MagneticWallSheet-module__container--sgm6B";
var _2 = "MagneticWallSheet-module__header--NUhV7";
var _3 = "MagneticWallSheet-module__inputRow--taOYl";
var _4 = "MagneticWallSheet-module__isSticky--aSKtk";
var _5 = "MagneticWallSheet-module__overflowMenu--pcRpA";
var _6 = "MagneticWallSheet-module__overlay--SGYqb";
var _7 = "MagneticWallSheet-module__titleRow--VSvH1";
export { _1 as "container", _2 as "header", _3 as "inputRow", _4 as "isSticky", _5 as "overflowMenu", _6 as "overlay", _7 as "titleRow" }
